class QuickviewButton extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    this.#abortController = new AbortController();

    this.querySelector('.quickview-button__trigger')?.addEventListener('click', this.#handleClick, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /**
   * Opens the existing quick-add modal from the associated product card.
   * @param {Event} event
   */
  #handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const card = this.closest('product-card');
    if (!card) return;

    card.querySelector('.quick-add__button--choose')?.click();
  };
}

if (!customElements.get('quickview-button')) {
  customElements.define('quickview-button', QuickviewButton);
}
